import { render, staticRenderFns } from "./VolunteerCoverage.vue?vue&type=template&id=563e3e95&scoped=true&"
import script from "./VolunteerCoverage.vue?vue&type=script&lang=js&"
export * from "./VolunteerCoverage.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerCoverage.vue?vue&type=style&index=0&id=563e3e95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e3e95",
  null
  
)

export default component.exports